module.exports = __webpack_public_path__ + "img/lazada.b95af1ff.png";